// extracted by mini-css-extract-plugin
export default {"container":"ij-z","blurb":"jj-z","links":"kj-z"};